/**
 * Google Search Console — אימות בעזרת תגית HTML.
 * הגדר בזמן build: REACT_APP_GOOGLE_SITE_VERIFICATION=<הערך מ־content בתגית מ־Search Console>
 * (בלי המילים google-site-verification=, רק הטוקן מתוך content="...")
 */
const token = process.env.REACT_APP_GOOGLE_SITE_VERIFICATION;
if (token && typeof document !== "undefined") {
  const v = String(token).trim();
  if (v) {
    const el = document.createElement("meta");
    el.setAttribute("name", "google-site-verification");
    el.setAttribute("content", v);
    document.head.appendChild(el);
  }
}
